import React from 'react';

import { MxnDepositDetails } from '@/Screens/Dashboard/Home/MxnDepositDetails';
import { VirtualAccountDetails } from '@/Screens/Dashboard/Home/VirtualAccountDetails';
import { WalletDetails } from '@/Screens/Dashboard/Home/WalletDetails';
import { CurrencyCodeType } from '@/types/currency';

interface Props {
  readonly currency: CurrencyCodeType;
  readonly beneficiaryId?: string;
  readonly virtualAccountId?: string;
}

export const AccountDetailsModal: React.FC<Props> = (props: Props): React.ReactElement => {
  const { currency, beneficiaryId, virtualAccountId } = props;

  switch (currency) {
    case CurrencyCodeType.USD:
      if (beneficiaryId) {
        return (
          <VirtualAccountDetails
            beneficiaryId={beneficiaryId}
            virtualAccountId={virtualAccountId}
          />
        );
      }

      return <></>;

    case CurrencyCodeType.USDC:
    case CurrencyCodeType.USDT:
      return <WalletDetails currency={currency} beneficiaryId={beneficiaryId} />;

    case CurrencyCodeType.MXNB:
      return <MxnDepositDetails beneficiaryId={beneficiaryId} />;

    default:
      console.warn('unsupported currency, cannot show details for: ', currency);
      return <></>;
  }
};
